/* Astro only: existing featured image first, approved ingredient image second. */
(function () {
  'use strict';
  if (window.__llzAstroIngredientsInstalled) return;
  window.__llzAstroIngredientsInstalled = true;
  const prefix = 'llz-ingredients-astro-';
  const approved = {"belier": "llz-ingredients-astro-belier-d2bb2e72c5f3.webp", "taureau": "llz-ingredients-astro-taureau-9d7c5ae921a4.webp", "gemeaux": "llz-ingredients-astro-gemeaux-5faa8281b1e7.webp", "cancer": "llz-ingredients-astro-cancer-dacb9f4feeef.webp", "lion": "llz-ingredients-astro-lion-01a0cabec9df.webp", "vierge": "llz-ingredients-astro-vierge-b4319feab4e5.webp", "balance": "llz-ingredients-astro-balance-2849eb36ed13.webp", "scorpion": "llz-ingredients-astro-scorpion-2d3fd890cc1b.webp", "sagittaire": "llz-ingredients-astro-sagittaire-7eb51d60d488.webp", "capricorne": "llz-ingredients-astro-capricorne-9ed175931e12.webp", "verseau": "llz-ingredients-astro-verseau-c8dcf25373ef.webp", "poissons": "llz-ingredients-astro-poissons-d2c1b0337187.webp"};
  function normalise(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z]/g, ''); }
  function fileOf(node) {
    const img = node.matches('img') ? node : node.querySelector('img');
    return img ? (img.getAttribute('src') || '').split('/').pop().split('?')[0] : '';
  }
  function mark(nodes, wanted) {
    let chosen = null;
    for (const el of nodes) {
      const file = fileOf(el);
      if (!file.startsWith(prefix)) continue;
      el.setAttribute('data-llz-astro-ingredient', '');
      const match = file === wanted && !chosen;
      el.toggleAttribute('data-llz-active', match);
      if (match) chosen = el; else el.classList.remove('is-active');
    }
    return chosen;
  }
  function sync() {
    const picker = document.querySelector('variant-radios, variant-selects');
    if (!picker) return;
    const selected = picker.querySelector('input:checked') || picker.querySelector('select');
    if (!selected) return;
    const sign = normalise(selected.value), wanted = approved[sign];
    let variants = [];
    try { variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent); } catch (_) { /* Hide nonmatching images even when variant metadata is unavailable. */ }
    const variant = variants.find(v => normalise(v.option1) === sign);
    const primaryId = variant && variant.featured_media && String(variant.featured_media.id);
    // Always filter the lightbox, including signs whose upload is not present yet.
    const modal = document.querySelector('product-modal .product-media-modal__content');
    if (modal) {
      const ingredient = mark(modal.querySelectorAll('[data-media-id]'), wanted);
      const primary = primaryId && modal.querySelector('[data-media-id="' + primaryId + '"]');
      if (primary && ingredient && primary.parentElement === ingredient.parentElement) {
        if (primary.parentElement.firstElementChild !== primary) primary.parentElement.prepend(primary);
        if (primary.nextElementSibling !== ingredient) primary.after(ingredient);
      }
    }
    for (const gallery of document.querySelectorAll('media-gallery')) {
      const slides = gallery.querySelector('[id^="Slider-Gallery"]');
      const thumbs = gallery.querySelector('[id^="Slider-Thumbnails"]');
      if (!slides || !thumbs) continue;
      const ingredient = mark(slides.children, wanted);
      const ingredientThumb = mark(thumbs.children, wanted);
      const primary = primaryId && [...slides.children].find(el => (el.dataset.mediaId || '').endsWith('-' + primaryId));
      if (ingredient && primary) {
        if (slides.firstElementChild !== primary) slides.prepend(primary);
        if (primary.nextElementSibling !== ingredient) primary.after(ingredient);
        const primaryThumb = [...thumbs.children].find(el => el.dataset.target === primary.dataset.mediaId);
        if (primaryThumb && ingredientThumb) {
          if (thumbs.firstElementChild !== primaryThumb) thumbs.prepend(primaryThumb);
          if (primaryThumb.nextElementSibling !== ingredientThumb) primaryThumb.after(ingredientThumb);
        }
      }
      const visible = [...thumbs.children].filter(el => getComputedStyle(el).display !== 'none');
      visible.forEach((el, index) => {
        el.dataset.mediaPosition = String(index + 1);
        const button = el.querySelector('button');
        if (button) button.setAttribute('aria-label', 'Afficher l’image ' + (index + 1));
      });
      for (const slider of gallery.querySelectorAll('slider-component')) if (typeof slider.resetPages === 'function') slider.resetPages();
      gallery.dataset.llzIngredientSign = sign;
    }
  }
  function schedule() { requestAnimationFrame(sync); }
  document.addEventListener('llz-sign-change', schedule);
  document.addEventListener('change', e => { if (e.target.closest('variant-radios,variant-selects')) schedule(); });
  window.addEventListener('popstate', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
